/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S3_HeadingInputs */

const tr_iletisim_s3_heading = /** @type {(inputs: Iletisim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK ve Kişisel Veri Başvuruları`)
};

const en_iletisim_s3_heading = /** @type {(inputs: Iletisim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK and personal data requests`)
};

const de_iletisim_s3_heading = /** @type {(inputs: Iletisim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK und Anträge zu personenbezogenen Daten`)
};

const ru_iletisim_s3_heading = /** @type {(inputs: Iletisim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK и заявления по персональным данным`)
};

/**
* | output |
* | --- |
* | "KVKK and personal data requests" |
*
* @param {Iletisim_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s3_heading = /** @type {((inputs?: Iletisim_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s3_heading(inputs)
	if (locale === "de") return de_iletisim_s3_heading(inputs)
	if (locale === "ru") return ru_iletisim_s3_heading(inputs)
	return tr_iletisim_s3_heading(inputs)
});